import { createContext } from 'react';
var NavContext = createContext({
    hasMenu: false,
    setHasMenu: function () { return undefined; },
    openMenuMobile: false,
    setOpenMenuMobile: function () { return undefined; },
    openModaleRecherche: false,
    setOpenModaleRecherche: function () { return undefined; },
});
export default NavContext;
